<template>
  <div v-if="xs" class="d-flex flex-row verlauf-header font-size">
    <div class="xs-point"></div>
    <div class="xs-location flex-grow-1">{{ $t('fahrdienst452.longname') }}</div>
    <div class="xs-an">{{ $t('fahrdienst452.an') }}</div>
    <div class="xs-ab">{{ $t('fahrdienst452.ab') }}</div>
  </div>
  <div v-else class="d-flex flex-row verlauf-header">
    <div class="point pl-2">&nbsp;</div>
    <div class="location">{{ $t('fahrdienst452.longname') }}</div>
    <template v-for="col in perlschnurColumns">
      <div v-if="col.key === 'abbr'" :key="col.key" class="abbreviation">{{ $t(col.titleKey) }}</div>
      <div v-if="col.key === 'line'" :key="col.key" class="line">{{ $t(col.titleKey) }}</div>
      <div v-if="col.key === 'kurs'" :key="col.key" class="track">{{ $t(col.titleKey) }}</div>
      <div v-if="col.key === 'zone'" :key="col.key" class="zone">{{ $t(col.titleKey) }}</div>
      <div v-if="col.key === 'custom1'" :key="col.key" class="zone">{{ $t(col.titleKey) }}</div>
    </template>
    <div class="an">{{ $t('fahrdienst452.an') }}</div>
    <div class="ab">{{ $t('fahrdienst452.ab') }}</div>
    <div class="notice-and-connection-header flex-grow-1">
      {{ $t('fahrdienst452.comment') }} /
      {{ $t('fahrdienst452.connection') }}
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';

export default {
  name: 'VerlaufHeader',
  props: {
    perlschnurColumns: Array,
    perlschnurColumnsXs: Array,
  },
  mixins: [common, configMixin],
};
</script>
<style lang="scss" scoped>
@import './perlschnur.scss';
</style>
